import { render } from "./Labels.vue?vue&type=template&id=82395c28"
import script from "./Labels.vue?vue&type=script&lang=js"
export * from "./Labels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__